import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonPage, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack, peopleOutline, sendOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { assinaUrl, listaEquipePorPerfil, postMensagens, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './EnviarMensagensClientes.css';

const EnviarMensagensClientes: React.FC = () => {

  const history = useHistory();
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [listaCliente, setListaCliente] = useState<any>([]);
  const [cliente, setCliente] = useState<any>();
  // Modo de entrada de clientes (seleção ou CSV)
  const [modoEntrada, setModoEntrada] = useState<'selecionar' | 'csv'>('selecionar');
  const [csvTexto, setCsvTexto] = useState<string>("");
  const [csvClientes, setCsvClientes] = useState<Array<{ nome: string; telefone: string }>>([]);
  const [showLoading, setShowLoading] = useState(false);
  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [mensagem, setMensagem] = useState("🚨 {Cansado de pagar caro?|Chega de mensalidades altas!|Chegou a hora de parar de desperdiçar dinheiro com mensalidades altas?|Por que continuar pagando mensalidades e taxas altas?}\n🔥 {Promoção especial|Oferta exclusiva|Desconto especial}:\n👉 {50% OFF — só R$ 99,90|De R$ 199,90 por apenas R$ 99,90 (50% OFF)|Xeguei por metade do preço: só R$ 99,90}\nE tem mais: 7 dias grátis para testar 🚀\nFaça seu cadastro aqui 👉 https://xeguei.com.br/?convite=desconto50\n{Com o Xeguei você tem um sistema completo pagando bem menos. Quer que eu te mostre como funciona?|No Xeguei você paga menos e ainda tem tudo que precisa. Quer que eu explique rapidinho?|Com o Xeguei, você tem um sistema completo gastando menos. Quer que eu te mostre na prática?}");
  //useState("XEGUEI - {Promoção especial|Oferta imperdível|Desconto exclusivo|Novidade quentinha} 🚀\n{50% OFF — só R$ 99,90|Xeguei com 50% de desconto: R$ 99,90|De R$ 199,90 por apenas R$ 99,90 (50% OFF)|Assine hoje com 50% OFF: só R$ 99,90}\nFaça seu cadastro e aproveite 7 dias grátis 👉 https://xeguei.com.br/?convite=desconto50\n{Quer saber mais?|Te mando os detalhes?|Posso te explicar rapidinho?|Curtiu a ideia?}");
  // Estados de imagem
  const [fileArquivos, setFileArquivos] = useState<any>(null);
  const [fileDataURL, setFileDataURL] = useState<string | null>(null);
  // Metadados da imagem serão usados apenas em memória ao enviar
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

  useIonViewDidEnter(() => {
    // document.getElementsByTagName("ion-tab-bar")[0].style.display = "none";
    consultarCliente();
  });


  function readCliente() {
    return listaCliente.map((value: any, index: any, array: any) =>
    (
      <IonSelectOption key={"cliente" + value.pk} value={[value.nome, value.telefone]}>{value.nome}</IonSelectOption>
    )
    )
  };

  // Utilitário simples para dividir uma linha CSV respeitando aspas
  function splitCsvLine(line: string): string[] {
    const regex = /,(?=(?:[^"]*"[^"]*")*[^"]*$)/g; // vírgulas fora de aspas
    return line
      .split(regex)
      .map((s) => s.trim().replace(/^\"|\"$/g, ''));
  }

  function normalizarTelefone(raw: string): string {
    if (!raw) return '';
    // Pega primeiro número se houver múltiplos separados por espaço/; ,
    const primeiro = String(raw).split(/[;,\s]+/).filter(Boolean)[0] || '';
    let tel = primeiro.replace(/[^+\d]/g, '');
    // Se começa com '55' sem '+', prefixa '+' para padrão internacional
    if (tel.startsWith('55') && !tel.startsWith('+')) tel = '+' + tel;
    // Se só dígitos nacionais (10-11), opcionalmente poderíamos adicionar +55, mas manteremos como está para não assumir DDI
    return tel;
  }

  function parseCsvClientes(texto: string): Array<{ nome: string; telefone: string }> {
    if (!texto || !texto.trim()) return [];
    const linhas = texto.split(/\r?\n/).filter((l) => l.trim().length > 0);
    const headerCols = splitCsvLine(linhas[0]);
    const header = headerCols.map((h) => h.toLowerCase().trim());
    const idxNome = header.findIndex((h) => h === 'nome' || h === 'name');
    const idxWhats = header.findIndex((h) => h === 'whatsapp_numbers' || h === 'whatsapp');
    const idxTelefone = header.findIndex((h) => h === 'telefone' || h === 'phone');

    const out: Array<{ nome: string; telefone: string }> = [];

    const temCabecalhoReconhecido = idxNome >= 0 || idxWhats >= 0 || idxTelefone >= 0;

    if (temCabecalhoReconhecido) {
      for (let i = 1; i < linhas.length; i++) {
        const cols = splitCsvLine(linhas[i]);
        const nome = idxNome >= 0 ? (cols[idxNome] || '').trim() : '';
        let telefoneRaw = idxWhats >= 0 ? (cols[idxWhats] || '') : '';
        if (!telefoneRaw && idxTelefone >= 0) telefoneRaw = cols[idxTelefone] || '';
        const telefone = normalizarTelefone(telefoneRaw);
        if (nome && telefone && telefone.replace(/\D/g, '').length >= 10) {
          out.push({ nome, telefone });
        }
      }
      return out;
    }

    // Fallback: sem cabeçalho. Assumir primeira coluna = nome, segunda = telefone
    for (let i = 0; i < linhas.length; i++) {
      const cols = splitCsvLine(linhas[i]);
      if (cols.length < 2) continue;
      const nome = (cols[0] || '').trim();
      const telefone = normalizarTelefone(cols[1] || '');
      if (nome && telefone && telefone.replace(/\D/g, '').length >= 10) {
        out.push({ nome, telefone });
      }
    }
    return out;
  }

  // Parseia automaticamente quando o texto CSV muda
  React.useEffect(() => {
    if (modoEntrada === 'csv') {
      const parsed = parseCsvClientes(csvTexto);
      setCsvClientes(parsed);
    }
  }, [csvTexto, modoEntrada]);

  // Assina URL S3 e faz upload do arquivo selecionado, retornando dados da imagem
  const assinaUploadS3ArquivoESalvar = async (file: File) => {
    try {
      const fileParts = file && file.name ? file.name.split('.') : [];
      const fileNameArquivo = fileParts[0] || 'arquivo';
      const fileTypeArquivo = fileParts[1] || 'png';

      const params = {
        nome: fileNameArquivo,
        tipo: fileTypeArquivo
      };

      const resp = await fetch(assinaUrl.url.concat("?pasta=campanhas-mensagens&bucket=xeguei-mobile-publico"), {
        method: assinaUrl.method,
        headers: new Headers([["token", localStorage.getItem("token") || ""]]),
        body: JSON.stringify(params),
        credentials: 'include' as RequestCredentials
      });

      const response = await resp.json();
      if (response.Item) {
        const uploadToS3 = await fetch(response.Item.urlAssinado, {
          method: 'PUT',
          headers: {
            'Content-Type': 'image/' + fileTypeArquivo,
          },
          body: file,
        });
        if (uploadToS3.status === 200) {
          return {
            urlImagem: response.Item.urlPublica,
            nomeImagem: response.Item.fileName,
            tipoImagem: fileTypeArquivo
          };
        } else {
          throw new Error('Erro ao fazer upload do arquivo.');
        }
      } else {
        throw new Error('Erro ao assinar a URL.');
      }
    } catch (error) {
      console.error('Erro no upload:', error);
      throw error;
    }
  };

  const consultarCliente = async (empresaid?: any) => {
    try {
      setShowLoading(true);

      const url = listaEquipePorPerfil.url
        .replace("{perfil}", "cliente")
        .concat("?lojas=" + Buffer.from(loja).toString('base64'));

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: listaEquipePorPerfil.method
          },
          history,
          (response) => {
            if (response.Items) {
              const lista = response.Items.sort((a: any, b: any) =>
                a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : -1
              );
              setListaCliente(lista);
            } else {
              setListaCliente([]);
            }
            resolve();
          },
          (error) => {
            setListaCliente([]);
            reject(new Error(error.message || "Erro ao carregar lista de clientes"));
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao consultar clientes:", error);
      setTextToast(error.message || "Erro ao carregar lista de clientes. Tente novamente.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }

  function validarCampos() {
    if (!mensagem || mensagem.length === 0) {
      setTextToast('Mensagem é obrigatória.');
      setShowToast(true);
      return false;
    }

    if (modoEntrada === 'selecionar') {
      if (cliente && cliente.length > 0) return true;
      setTextToast('Selecione ao menos um cliente.');
      setShowToast(true);
      return false;
    } else {
      if (csvClientes.length > 0) return true;
      setTextToast('Nenhum cliente válido encontrado no CSV. Verifique se há colunas Nome e WhatsApp_Numbers e números válidos.');
      setShowToast(true);
      return false;
    }
  }

  const enviar = async () => {
    if (!validarCampos())
      return;

    console.log('listaCliente', listaCliente);

    if (!botaoAtivo) return;

    try {
      setShowLoading(true);
      setBotaoAtivo(false);

      // Validação adicional
      if (!loja) {
        throw new Error("Loja não identificada");
      }

      // Processa os clientes selecionados para o formato correto
      let clientesProcessados: Array<{ nome: string, telefone: string }> = [];
      if (modoEntrada === 'selecionar') {
        if (cliente && cliente.length > 0) {
          cliente.forEach((clienteSelecionado: any) => {
            if (Array.isArray(clienteSelecionado)) {
              clientesProcessados.push({
                nome: clienteSelecionado[0],
                telefone: clienteSelecionado[1]
              });
            }
          });
        }
      } else {
        clientesProcessados = csvClientes;
      }

      if (clientesProcessados.length === 0) {
        throw new Error("Nenhum cliente válido selecionado");
      }

      // Upload da imagem se houver arquivo selecionado
      let dadosImagem: any = null;
      if (fileArquivos) {
        try {
          dadosImagem = await assinaUploadS3ArquivoESalvar(fileArquivos);
          // usa dadosImagem diretamente no payload
        } catch (err) {
          setTextToast('Erro ao fazer upload da imagem.');
          setShowToast(true);
          throw err;
        }
      }

      let objRequest: any = {
        mensagem: mensagem,
        clientes: clientesProcessados,
        empresaid: loja
      };

      // Adiciona campos de imagem se houver dados de upload ou imagem existente
      if (dadosImagem) {
        objRequest.urlImagem = dadosImagem.urlImagem;
        objRequest.nomeImagem = dadosImagem.nomeImagem;
        objRequest.tipoImagem = dadosImagem.tipoImagem;
      }

      // Inclui domínio apenas se estiver definido
      if (dadosEmpresa?.dominio) {
        objRequest.dominio = dadosEmpresa.dominio;
      }

      console.log("Enviando campanha:", objRequest);

      // Usando requestService melhorado
      await new Promise<void>((resolve, reject) => {
        requestService(
          postMensagens.url,
          {
            method: postMensagens.method,
            body: JSON.stringify(objRequest)
          },
          history,
          (response) => {
            if (response.message) {
              setCliente('');
              setTextToast("Mensagens enviadas com sucesso.");
              setShowToast(true);
              resolve();
            } else {
              reject(new Error("Resposta inválida do servidor"));
            }
          },
          (error) => {
            // RequestService agora já trata todos os erros adequadamente
            reject(new Error(error.message || "Erro ao enviar mensagens"));
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao enviar mensagens:", error);
      setTextToast(error.message || "Erro inesperado ao enviar mensagens.");
      setShowToast(true);
    } finally {
      setBotaoAtivo(true);
      setShowLoading(false);
    }
  }

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Enviar Agora</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>
        <IonGrid>
          {/* Card de seleção de clientes */}
          <IonCard>
            <IonCardContent>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <IonIcon icon={peopleOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)', marginRight: '10px' }} />
                <h2 style={{ margin: 0, fontWeight: 'bold' }}>Clientes</h2>
              </div>
              <p style={{ color: '#666', marginBottom: '12px' }}>Escolha como adicionar os clientes que receberão a mensagem</p>

              <IonSegment value={modoEntrada} onIonChange={(e: any) => setModoEntrada(e.detail.value)}>
                <IonSegmentButton value="selecionar">Selecionar</IonSegmentButton>
                <IonSegmentButton value="csv">CSV</IonSegmentButton>
              </IonSegment>

              {modoEntrada === 'selecionar' ? (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', margin: '15px 0' }}>
                    <IonLabel>Clientes selecionados: {cliente ? cliente.length : 0}</IonLabel>
                  </div>

                  <IonSelect
                    multiple={true}
                    value={cliente}
                    placeholder="Selecione os clientes"
                    onIonChange={e => { setCliente(e.detail.value); }}
                    style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px', width: '100%' }}
                  >
                    {readCliente()}
                  </IonSelect>
                </>
              ) : (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', margin: '15px 0' }}>
                    <IonLabel>Clientes válidos no CSV: {csvClientes.length}</IonLabel>
                  </div>
                  <IonTextarea
                    placeholder={'Cole aqui o CSV com as colunas Nome e WhatsApp_Numbers'}
                    value={csvTexto}
                    onIonInput={(e: any) => setCsvTexto(e.target.value)}
                    rows={8}
                    style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px', width: '100%' }}
                  />
                  <div style={{ color: '#666', fontSize: '12px', marginTop: '6px' }}>
                    Ex. com cabeçalho: "Nome","WhatsApp_Numbers"\n"Minha Pizzaria","+5511999999999"<br />
                    Também aceitamos sem cabeçalho (2 colunas): "Minha Pizzaria","+5511999999999"
                  </div>
                </>
              )}

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', marginTop: '30px' }}>
                <IonIcon icon={sendOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)', marginRight: '10px' }} />
                <h2 style={{ margin: 0, fontWeight: 'bold' }}>Mensagem</h2>
              </div>
              <p style={{ color: '#666', marginBottom: '20px' }}>Digite a mensagem que será enviada aos clientes</p>

              {/* Upload de imagem (opcional) */}
              <div style={{ marginBottom: '20px', marginTop: '10px' }}>
                <h3 style={{ margin: 0, marginBottom: '10px', fontSize: '16px' }}>Imagem (opcional)</h3>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e: any) => {
                    const file = e.target.files[0];
                    if (file) {
                      setFileArquivos(file);
                      const reader = new FileReader();
                      reader.onload = (ev) => {
                        setFileDataURL(ev.target?.result as string);
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                  style={{ marginBottom: '10px' }}
                />
                {fileDataURL && (
                  <div style={{ marginTop: '10px' }}>
                    <img
                      src={fileDataURL}
                      alt="Preview"
                      style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '5px' }}
                    />
                  </div>
                )}
              </div>

              <IonTextarea
                placeholder="Digite sua mensagem..."
                value={mensagem}
                onIonInput={(e: any) => setMensagem(e.target.value)}
                rows={6}
                style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px' }}
                maxlength={500}
              />

              <div style={{ textAlign: 'right', fontSize: '12px', color: '#666', marginTop: '5px' }}>
                {mensagem.length}/500 caracteres
              </div>
            </IonCardContent>
          </IonCard>
        </IonGrid>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>

      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton onClick={enviar}
            expand="block"
            disabled={!botaoAtivo || acessos?.campanhas !== 'edicao'}
            style={{ margin: '10px' }}
          >
            ENVIAR
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default EnviarMensagensClientes;